import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { Constant } from "../config/constant";
import { LangConfig } from "../config/lang.config";
import { BrowserDbService } from "./browser-db.service";
import { TranslateService } from "@ngx-translate/core";
import { TranslationModuleEnum } from "src/app/utils/translation-modules.enum";
import { sharedModules } from "src/app/utils/translateModules";

@Injectable({
  providedIn: "root",
})
export class TranslateConfigService {
  private langSelected$: BehaviorSubject<string>;
  langChangeObserver: Observable<string>;

  translateionchanged$: Subject<any> = new Subject();

  constructor(
    private browserDbService: BrowserDbService,
    private translate: TranslateService
  ) {
    this.langSelected$ = new BehaviorSubject("ar");
    this.langChangeObserver = this.langSelected$.asObservable();
    this.setLanguage();
    translate.onTranslationChange.subscribe(evt => {
      this.translateionchanged$.next(evt.translations);
    });
  }

  getSystemLang(): any {
    const local = this.browserDbService.getItem(Constant.locale);
    if (local) return local;
    else return LangConfig.AR;
  }

  setLanguage(lang?: string) {
    this.browserDbService.setItem(
      Constant.locale,
      lang || this.getSystemLang()
    );
    this.langSelected$.next(lang || this.getSystemLang());

    this.getSystemLang() == LangConfig.AR
      ? this.chengeDir("rtl")
      : this.chengeDir("ltr");
  }

  chengeDir(custemDir: string) {
    document.documentElement.setAttribute("dir", custemDir);
  }

  // : Observable<{ en: string; ar: string }>
  getLangText(key: string) {
    let mergedTranslationFile = JSON.parse(
      sessionStorage.getItem("translation_file_mergedTranslations") || "{}"
    );

    if (
      mergedTranslationFile === "undefined" ||
      mergedTranslationFile === null
    ) {
      mergedTranslationFile = {};
    }

    const { en, ar } = mergedTranslationFile;

    if (!mergedTranslationFile) return true;

    // Check if the key exists in the translation file
    const keyPath = key?.split(".");
    const moduleKeyName = keyPath?.shift(); // Remove the first element of the array

    if (!moduleKeyName || !en || !ar) return { en: undefined, ar: undefined };

    const valueEn = this.getNestedValue(en[moduleKeyName], keyPath);
    const valueAr = this.getNestedValue(ar[moduleKeyName], keyPath);

    return { en: valueEn, ar: valueAr };
  }

  getNestedValue(obj: any, path: string[]) {
    return path.reduce(
      (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
      obj
    );
  }

  getAllTranslationFiles() {
    let translationFiles = [];
    for (let i = 0; i < localStorage.length; i++) {
      let key = localStorage.key(i);
      if (key.startsWith("translation_file_")) {
        let value = localStorage.getItem(key);
        // Parse JSON if needed
        try {
          value = JSON.parse(value);
        } catch (error) {
          console.error("Error parsing JSON:", error);
          // Handle parsing error if needed
        }
        translationFiles.push({ key: key, value: value });
      }
    }
    return translationFiles;
  }

  mergeTranslationFiles(modules) {
    modules = [...sharedModules, ...modules];
    let fileMergedConverted = {};

    function getTranslationItems() {
      let translationItems = {};
      for (let i = 0; i < localStorage.length; i++) {
        let key = localStorage.key(i);
        if (key.startsWith("translation_file_")) {
          translationItems[key] = localStorage.getItem(key);
        }
      }
      return translationItems;
    }

    // Call the function to get all localStorage items that start with "translation_file_"
    let translationItems = getTranslationItems();
    modules?.forEach(module => {
      let file = localStorage.getItem(
        `translation_file_${TranslationModuleEnum[module]}`
      );
      let fileConverted = JSON.parse(file);
      if (fileConverted) {
        fileMergedConverted = {
          ...fileConverted[this.translate?.currentLang],
          ...fileMergedConverted,
        };
      }
    });

    return fileMergedConverted;
  }

  // mergeTranslationFiles2(modules, callback) {
  //   modules = [...sharedModules, ...modules];
  //   let fileMergedConverted = {};
  //   modules?.forEach(module => {
  //     let file = localStorage.getItem(
  //       `translation_file_${TranslationModule[module]}`
  //     );
  //     let fileConverted = JSON.parse(file);
  //     fileMergedConverted = {
  //       ...fileMergedConverted,
  //       ...fileConverted[this.translate.currentLang],
  //     };
  //   });
  //   callback(fileMergedConverted);
  // }

  // mergeTranslationFiles2() {
  //   let modules = this.getAllTranslationFiles()
  //   let fileMergedConverted = {}
  //     modules.forEach(module => {
  //       let file = localStorage.getItem(`${module['key']}`);
  //       let fileConverted = JSON.parse(file);
  //       fileMergedConverted = {...fileMergedConverted, ...fileConverted }
  //     });
  //   return fileMergedConverted;
  // }
}
